module.exports = __webpack_public_path__ + "img/01_DSC7437-min.cd28c7f2.jpg";